export * from './lang-switcher/lang-switcher.component';
